module.exports = __webpack_public_path__ + "img/logo.13d9a288.png";